import { Component, computed, effect, inject, Signal } from '@angular/core';
import { CompanyGroupsListComponent } from '@app/shared/components/groups/company-groups-list/company-groups-list.component';
import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { GroupsDataService } from '@app/shared/services/groups-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { Group } from '@app/shared/types/models/group/group.model';
import { UiPageWrapperComponent } from '@app/shared/ui/page-wrapper/ui-page-wrapper.component';
import { UiSpinnerDirective } from '@app/shared/ui/spinner/ui-spinner.directive';

@Component({
  selector: 'proffeo-groups',
  templateUrl: './company-groups-view.component.html',
  imports: [UiPageWrapperComponent, CompanyGroupsListComponent, UiSpinnerDirective]
})
export class CompanyGroupsViewComponent {
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);
  private readonly groupsService: GroupsDataService = inject(GroupsDataService);

  private readonly loadCompanyGroupsEffect = effect(() => {
    const company = this.activeCompany();
    if (company?.id) {
      this.groupsService.loadCompanyGroups(company.id);
    }
  });

  protected activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;

  protected companyGroups: Signal<Group[] | undefined> = computed(() => {
    const company = this.activeCompany();
    return this.groupsService.getCompanyGroups(company?.id ?? '')();
  });
}
